import { render, staticRenderFns } from "./EmployeeProfile.vue?vue&type=template&id=d8831b14&scoped=true"
import script from "./EmployeeProfile.vue?vue&type=script&lang=js"
export * from "./EmployeeProfile.vue?vue&type=script&lang=js"
import style0 from "./EmployeeProfile.vue?vue&type=style&index=0&id=d8831b14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8831b14",
  null
  
)

export default component.exports